// modal-contact ile contact-form olaylarla haberleşir
import { applyValidations, clearValidations } from "./form-validations";

document.addEventListener("DOMContentLoaded", () => {
  const /** @type HTMLDivElement */ modal_contact =
    document.getElementById("modal-contact");
  const /** @type HTMLFormElement */ contact_form =
    document.getElementById("contact_form");
  if (!modal_contact || !contact_form) {
    return;
  }
  contact_form.addEventListener("submit", async (e) => {
    e.preventDefault();
    await grecaptcha.execute();
  });
  contact_form.addEventListener("submitAfterRecaptcha", async (e) => {
    const /** @type HTMLButtonElement */ submitButton =
      contact_form.querySelector('button[type="submit"][data-loading-text]');
    const f = new FormData(contact_form);
    if (submitButton) {
      submitButton.setAttribute("data-original-text", submitButton.innerText);
      submitButton.innerText = submitButton.dataset.loadingText;
      submitButton.disabled = true;
    }
    const data = await fetch(contact_form.action, {
      method: "POST",
      body: f,
    }).then((response) => response.json());
    if (submitButton) {
      submitButton.innerText = submitButton.getAttribute("data-original-text");
      submitButton.disabled = false;
    }
    if (data.validations) {
      applyValidations(contact_form, data.validations);
      return;
    } else {
      clearValidations(contact_form);
    }

    if (dataLayer) {
      /**
       * Bu değişkenler LetsCallYou olayında kullanılacak.
       * Olayı burada tetiklemiyoruz, çünkü kullanıcının SMS doğrulaması
       * yapıp yapmamasına göre kod burada dallanıyor.
       * Kullanıcı SMS doğrulamasına yönlenip orada işi bitirirse orada da bir event tetiklenmeli.
       * Kod tekrarından kaçınmak için önce değişkenleri dolduruyoruz.
       * 
       * "contact-ok" olayının dinlendiği modal-contact.js içinden "LetsCallYou" tetikleniyor.
       */
      dataLayer.push({
        "LetsCallYou": {
          "Email": data.email,
          "Phone": data.phone_number,
        }
      });
    }

    if ("phone-verification" === data.action) {
      modal_contact.dispatchEvent(new CustomEvent("phone-verification"));
      return;
    }
    if (data.status) {
      modal_contact.dispatchEvent(new CustomEvent("contact-ok"));
    }
  });
});
